import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Errored from '../../core/Errored';
import EventBar from '../../core/EventBar';
import EventProvider from '../../core/providers/EventProvider';
import ProjectProvider from '../../core/providers/ProjectProvider';
import { processHashLocation } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import TaxonomyData from './TaxonomyData';
import TaxonomyEditorContainer from './TaxonomyEditorContainer';

class TaxonomyManager extends Component {

  constructor(props) {
    super(props);
    const initState = TaxonomyManager.computeState(props);
    this.state = Object.assign(
      {
        viewValue: 1
      }, initState);
  }

  static getDerivedStateFromProps(props) {
    return TaxonomyManager.computeState(props);
  }

  static computeState(props) {
    const paramsMap = processHashLocation(props.location);
    const taxonomyIRI = paramsMap.get("taxonomy");
    let isErrored = !taxonomyIRI || taxonomyIRI === "";
    try {
      const projectData = GS.data(props.id, props.graph);
      if (!projectData.hasComponent.includes(taxonomyIRI)) isErrored = true;
    }
    catch (e) {
      isErrored = true;
    }
    return {
      taxonomyIRI,
      isErrored
    };
  }

  toggleTaxonomyDetail = (value) => this.setState({ viewValue: value });

  render() {


    const { viewValue, taxonomyIRI, isErrored } = this.state;
    const { project, data, graph, entitlements, taxonomies, projectUsers, collections, ontologyProjects } = this.props;

    if (isErrored) return <Errored data={{ message: "This taxonomy may have just been deleted or an invalid taxonomy IRI has been provided in the URL." }} />;

    return (
      <ProjectProvider value={this.props.data}>
        <EventProvider>
          <EventBar defaultLang={data.defaultLang} />
        </EventProvider>
        {
          viewValue === 0 ?
            <TaxonomyData
              projectIRI={this.props.data.id}
              entitlements={entitlements}
              toggleTaxonomyDetail={this.toggleTaxonomyDetail}
              ontologyProjects={ontologyProjects}
              graph={graph}
              key={taxonomyIRI}
              id={taxonomyIRI} />
            :
            <TaxonomyEditorContainer
              location={this.props.location}
              entitlements={entitlements}
              expectedTypes={["ConceptScheme"]}
              project={project}
              collections={collections}
              taxonomies={taxonomies}
              projectUsers={projectUsers}
              ontologyProjects={ontologyProjects}
              toggleTaxonomyDetail={this.toggleTaxonomyDetail}
              key={taxonomyIRI}
              id={taxonomyIRI}
              graph={graph}
              skosXL={data.skosXL || false}
              defaultLang={data.defaultLang} />
        }
      </ProjectProvider>
    );
  }
}

TaxonomyManager.propTypes = {
  entitlements: PropTypes.array.isRequired,
  location: PropTypes.object,
  data: PropTypes.object.isRequired,
  collections: PropTypes.array,
  taxonomies: PropTypes.array,
  projectUsers: PropTypes.array,
  graph: PropTypes.string.isRequired,
  ontologyProjects: PropTypes.array,
  project: PropTypes.string.isRequired
};

export default withRouter(TaxonomyManager);